<!-- 底座绑定历史 -->
<template>
  <modal
    :visible.sync="show"
    :title="$t('integration.binding_history')"
    width="600px"
  >
    <div>
      <!-- 搜索 -->
      <div class="uk-flex uk-flex-center uk-flex-middle">
        <span class="mr-5">{{ $t('integration.time') }}</span>

        <el-date-picker
          class="mr-5"
          :value-format="'timestamp'"
          v-model="timeRange"
          type="datetimerange"
          range-separator="To"
          start-:placeholder="$t('integration.start_date')"
          end-:placeholder="$t('integration.end_date')"
        >
        </el-date-picker>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="getListFn"
        ></el-button>
      </div>

      <!-- 列表 -->
      <div
        class="uk-margin-small-top"
        style="width: 90%;margin:0 auto;height: 300px;overflow-y: auto;"
      >
        <template v-if="historyList.length">
          <div
            class="border mb-5 uk-flex uk-flex-middle uk-text-center"
            v-for="item in historyList"
            style="line-height: 30px;border-radius: 5px;"
            :key="item.id"
          >
            <!-- 绑定解绑图标 -->
            <div class="w-10 bd-r">
              <i v-icon:theme="['baseBindStatusConvert', item.bind]"></i>
            </div>

            <!-- 绑定的传感器名称 -->
            <div class="uk-flex-1 bd-r">
              {{ item.deviceCode }}
            </div>

            <!-- 绑定时间 -->
            <div class="uk-flex-1">
              {{ $timetransition(item.updateTime) }}
            </div>
          </div>
        </template>

        <template v-else>
          <el-empty></el-empty>
        </template>
      </div>
      <div class="uk-flex uk-flex-right" style="width: 90%;margin:0 auto;">
        <Pagination
          class="pagination"
          :total="pagination.total"
          :page.sync="model.iDisplayStart"
          :limit.sync="model.iDisplayLength"
          @pagination="getListFn"
        ></Pagination>
      </div>
    </div>
  </modal>
</template>

<script>
import bus from '@/utils/bus'
import { getHistoryPage } from '@/api/modules/base'

export default {
  data () {
    return {
      timeRange: [0, new Date().getTime()],
      pagination: {
        total: 0
      },
      show: false,
      model: {
        iDisplayStart: 0,
        iDisplayLength: 10,
        plinthId: 0,
        from: null,
        to: null
      },
      historyList: []
    }
  },
  watch: {
    'model.plinthId': {
      handler () {
        this.getListFn()
      }
    },
    timeRange () {
      if (this.timeRange && this.timeRange.length) {
        this.model.from = this.timeRange[0]
        this.model.to = this.timeRange[1]
      } else {
        this.model.from = null
        this.model.to = null
      }
    }
  },
  methods: {
    getListFn () {
      getHistoryPage(this.model).then(res => {
        const { pageInfo, result } = res.result.page
        if (res.result.from) {
          this.model.from = res.result.from
          this.model.to = res.result.to
          this.timeRange = [res.result.from, res.result.to]
        }

        this.pagination.total = pageInfo.total
        this.historyList = result
      })
    }
  },
  mounted () {
    bus.$on('bindHistoryParam', baseId => {
      // 传入底座id 查看底座绑定历史
      this.show = true
      this.model.plinthId = baseId
    })
  },
  beforeDestroy () {
    bus.$off('bindHistoryParam')
  }
}
</script>
